import React from 'react';
import { Container, Paper } from 'library';

import CMSContent from '../../common/CMSContent/CMSContent';
import EqualColumnForm from './EqualColumnForm/EqualColumnForm';
import FancyForm from './FancyForm/FancyForm';

const FormBlock = ({ data = {} }) => {
  const fields = data.block?.blockFields;
  const { theme, formBlock } = fields;
  const { blockHeader, blockText, formHeader, form, blockContent, style } = formBlock;
  const formData = form && form[0];

  let formBlockComponent = null;
  switch (style) {
    case 'equal':
      formBlockComponent = <EqualColumnForm formHeader={formHeader} blockContent={blockContent} form={formData} />;
      break;
    case 'fancy':
      formBlockComponent = <FancyForm formHeader={formHeader} blockContent={blockContent} form={formData} />;
      break;
    case 'centered':
      formBlockComponent = <FancyForm formHeader={formHeader} form={formData} />;
      break;
    default:
      break;
  }

  return (
    <Paper theme={theme} pad={{ top: 4, bottom: 4 }}>
      <Container>
        <div>
          {(blockHeader || blockText) && (
            <Container row justify="center">
              <Container grid={8}>
                {blockHeader && <h2>{blockHeader}</h2>}
                {blockText && <CMSContent content={blockText} />}
              </Container>
            </Container>
          )}
          {formBlockComponent}
        </div>
      </Container>
    </Paper>
  );
};

export default FormBlock;
